export default __webpack_public_path__ + "locales/bg/JavascriptSdk.json?hash=53b9694ec98e1b65b2522d9c6bd19a01";